import { useRouter } from "@tanstack/react-router";
import { setAthleteLabels, type GetAthletesResponse } from "api-client";

import { AthletesTable } from "src/components/CoachAthletesTable";
import { createLabelsCell } from "src/components/LabelsCell";

export { AthletesTable };

export const PAGE_SIZE = 20;

export type AthletesTab = "active" | "archived";

type AthletesData = GetAthletesResponse["data"];
export type Athlete = AthletesData["currentPage"][number];

interface CoachAthleteListProps {
  athletes: AthletesData;
  tab: AthletesTab;
}

export const athleteLabelsCell = createLabelsCell<Athlete>({
  getLabels: (athlete: Athlete) => {
    return athlete.labels;
  },
  save: (athlete: Athlete, labelIds: string[]) => {
    return setAthleteLabels({
      path: { athleteId: athlete.id },
      body: { labelIds },
    });
  },
});

export function CoachAthleteList(props: CoachAthleteListProps) {
  const router = useRouter();

  function onMutated() {
    router.invalidate();
  }

  return (
    <AthletesTable
      athleteList={props.athletes}
      tab={props.tab}
      onMutated={onMutated}
    />
  );
}

export interface AthleteTableProps {
  athleteList: AthletesData;
  tab: AthletesTab;
  onMutated: () => void;
}
